export default{
    waiting:Symbol(),
    loading:Symbol(),
    done:Symbol(),
    error:Symbol()
}